(function () {
  var mq = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initItemReveal(scope) {
    var items = scope.querySelectorAll('.urb-pairing__item');
    if (!items.length) return;
    if (mq.matches || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          obs.unobserve(el);
          setTimeout(function () { el.classList.add('is-in'); }, 420);
        }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  function init(scope) {
    var flow = scope.querySelector('[data-urb-pairing-flow]');
    if (!flow || flow.dataset.urbLineInit) return;
    flow.dataset.urbLineInit = '1';
    initItemReveal(scope);
    if (mq.matches) return;
    var ticking = false;
    var listening = false;
    function update() {
      ticking = false;
      var r = flow.getBoundingClientRect();
      var p = (window.innerHeight * 0.5 - r.top) / r.height;
      if (p < 0) p = 0;
      else if (p > 1) p = 1;
      flow.style.setProperty('--urb-line-p', p.toFixed(4));
    }
    function req() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }
    var io = new IntersectionObserver(function (entries) {
      var on = entries[0].isIntersecting;
      if (on && !listening) {
        listening = true;
        window.addEventListener('scroll', req, { passive: true });
        window.addEventListener('resize', req);
        update();
      }
      if (!on && listening) {
        listening = false;
        window.removeEventListener('scroll', req);
        window.removeEventListener('resize', req);
      }
    }, { rootMargin: '20% 0px' });
    io.observe(flow);
  }
  function boot() {
    document.querySelectorAll('.urb-pairing').forEach(init);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();